import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface PreviewConversationsFilterProps {
  filterIndex: number;
}

/**
 * Renders radio buttons for filtering preview conversations (test sessions)
 */
export const PreviewConversationsFilter = ({ filterIndex }: PreviewConversationsFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const isTest = useWatch({ control, name: `filters.${filterIndex}.isTest` });

  const handleChange = (value: string) => {
    let booleanValue: boolean | null;
    if (value === 'true') {
      booleanValue = true;
    } else if (value === 'false') {
      booleanValue = false;
    } else {
      booleanValue = null; // 'all' option
    }
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, isTest: booleanValue });
  };

  return (
    <div className="space-y-3">
      <RadioGroup value={isTest?.toString() || ''} onValueChange={handleChange} className="gap-0">
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
          <RadioGroupItem value="true" id={`preview-true-${filterIndex}`} />
          <Label htmlFor={`preview-true-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.onlyPreviewConversations')}
          </Label>
        </div>
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
          <RadioGroupItem value="false" id={`preview-false-${filterIndex}`} />
          <Label htmlFor={`preview-false-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.hidePreviewConversations')}
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
